import React, { Component } from 'react';
import { Table } from 'antd';
import { formatMoney } from '../../lib/util';

class SmallTableView extends Component {

  configToColumns=(config_list=[])=>{
      let cols=[];
      config_list.map((item)=>{
        cols.push({
          ...item,
          dataIndex:item.key,
          render:(val)=>{
            if(typeof val==='number'){
              return formatMoney(val,0)
            }else{
              return val
            }
          },
          className:'',
        })
      });
      return cols
  }
  render() {
    let item=this.props.data||{};
    let config=item.widget_config||[];
    let data=item.widget_data||[];
    // let meta=item.meta||{};
    // let columns=this.configToColumns(config);
    // console.log("datas",data,)
    return (
      <div> 
        <Table 
        size='small'
        className='noHover'
        // columns={[{
          
        // }]}
        // columns={columns}
        // rowClassName={(record={}, index) => {
        //   return {color:'red'}
        // }}
        dataSource={data}
        pagination={false}
        scroll={{
          x:true
        }}
        >
          {config.map((item)=>{
            let __meta__=item.__meta__||{};
            return <Table.Column key={item.key} dataIndex={item.key} title={<div
            style={{
              ...__meta__
            }}
            >
              {item.title}
            </div>}
            render={(value,record)=>{
              let __meta__ = record.__meta__||{};
              return {
                props: {
                  style: { ...__meta__ },
                },
                children: <div>{typeof val==='number'?formatMoney(value,0):value}</div>,
              };
              // <div style={{
              //   // ...__meta__
              // }}>
              //   {typeof val==='number'?formatMoney(value,0):value}
              // </div>
            }}
            />
          })}
        </Table>
      </div>
    );
  }
}

export default SmallTableView;
